import * as React from 'react';

const IconArrowDown = (props) => (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8 10.3402L13.4009 4.5L14 5.01191L8 11.5L2 5.01191L2.59914 4.5L8 10.3402Z" fill="black"/>
</svg>
);

export default IconArrowDown;